module.exports = __webpack_public_path__ + "img/cm.b4c9e39c.svg";